module.exports = __webpack_public_path__ + "img/logo12.e7fedb71.png";